module.exports = {
  'en': {
    'HRESS5UC1': {
      '0': '[HRESS5U] Approval Internal Recruitmant Application',
      '10': '[HRESS5U] Approval Internal Recruitmant Application',
      '20': 'No.',
      '30': 'Enter Date',
      '35': 'Seg No.',
      '40': 'Employee Code',
      '50': 'Employee name',
      '60': 'Current Position',
      '70': 'Applied for Position',
      '80': 'Department',
      '90': 'Current Status ',
      '99': 'Detail of Request',
      '100': 'Code Appr.',
      '110': 'Appr. Date',
      '120': 'Remark',
      '130': 'Next Approve'
    },
    'HRESS5UC2': {
      '0': 'Detail for Approved',
      '10': 'For Emp. Id.',
      '20': 'Approved Level',
      '30': 'Approved By :',
      '40': 'Date :',
      '50': 'Current Status',
      '60': 'Status',
      '70': 'Approved',
      '80': 'Refused',
      '90': 'Remark',
      '99': 'Request for Internal Recruitmant Application',
      '100': 'No.of  selected',
      '110': 'Record'
    },
    'HRESS5UC3': {
      '0': 'Detail for Open',
      '10': 'Detail for Open',
      '20': 'Emp.Code',
      '30': 'Record date',
      '40': 'Department',
      '50': 'Position',
      '60': 'Job Description',
      '70': 'Remark',
      '80': 'Available date',
      '90': 'List of Open for Position'
    },
    'HRESS5UC4': {
      '0': 'Detail Position for App.',
      '10': 'Detail Position for App.',
      '20': 'Department',
      '30': 'Position',
      '40': 'Job Description',
      '50': 'No. of Open',
      '60': 'Str. App. date',
      '70': 'Close App. date',
      '80': 'Qualification Spec.',
      '90': 'Job Description'
    },
    'HRESS5UC5': {
      '0': 'Qualification Requirement',
      '10': 'Qualification Requirement',
      '20': 'For P.R no.',
      '30': 'Position',
      '40': 'Job Description',
      '50': 'Last Employer"s Name',
      '60': 'Qualification Spec.',
      '70': 'By Job Spec.',
      '80': 'New Criteria',
      '90': 'Condition',
      '100': 'Remark'
    },
    'HRESS5UP1': {
      '0': 'Job Description',
      '10': 'Job Description',
      '20': 'Job Description',
      '30': 'Job Description',
      '40': 'Description',
      '50': 'Responsibility',
      '60': 'Security"s Requirement',
      '70': 'Collateral Value',
      '80': 'Baht',
      '90': 'No. of Guarantor',
      '100': 'Person',
      '110': 'Review Period',
      '120': 'Year',
      '130': 'Qualification',
      '140': 'Last Update Date',
      '150': 'By'
    },
    'HRESS5UP2': {
      '0': 'Job Detail',
      '10': 'Job Detail',
      '20': 'Item No.',
      '30': 'Item name',
      '40': 'Details'
    },
    'HRESS5UP3': {
      '0': 'Scope of Responsibility',
      '10': 'Scope of Responsibility',
      '20': 'Item No.',
      '30': 'Item name',
      '40': 'Details'
    },
    'HRESS5UP4': {
      '0': 'Competency',
      '10': 'Competency',
      '20': 'Type of Comp.',
      '30': 'Description',
      '40': 'Full Score'
    },
    'HRESS5UP5': {
      '0': 'Education',
      '10': 'Education',
      '20': 'Seq.',
      '30': 'Ed. Level',
      '40': 'Description',
      '50': 'Major',
      '60': 'Description',
      '70': 'GPA'
    }
  },
  'th': {
    'HRESS5UC1': {
      '0': '[HRESS5U] อนุมัติการรับสมัครภายใน',
      '10': '[HRESS5U] อนุมัติการรับสมัครภายใน',
      '20': 'ลำดับที่',
      '30': 'วันที่บันทึก',
      '35': 'ลำดับที่',
      '40': 'รหัสพนักงาน',
      '50': 'ชื่อพนักงาน',
      '60': 'ตำแหน่งปัจจุบัน',
      '70': 'สมัครตำแหน่ง',
      '80': 'หน่วยงาน',
      '90': 'สถานะปัจจุบัน',
      '99': 'รายละเอียดการสมัครภายใน',
      '100': 'ผู้อนุมัติ',
      '110': 'วันที่อนุมัติ',
      '120': 'หมายเหตุการอนุมัติ',
      '130': 'ผู้อนุมัติลำดับถัดไป'
    },
    'HRESS5UC2': {
      '0': 'รายละเอียดการอนุมัติ',
      '10': 'สำหรับพนักงาน',
      '20': 'ลำดับที่อนุมัติ',
      '30': 'รหัสผู้อนุมัติ ',
      '40': 'วันที่อนุมัติ',
      '50': 'สถานะปัจจุบัน',
      '60': 'สถานะ',
      '70': 'อนุมัติ',
      '80': 'ไม่อนุมัติ',
      '90': 'หมายเหตุ',
      '99': 'คำร้องเรื่อง การรับสมัครภายใน',
      '100': 'รายการที่เลือกทั้งหมด',
      '110': 'รายการ'
    },
    'HRESS5UC3': {
      '0': 'รายละเอียดการรับสมัคร',
      '10': 'รายละเอียดการรับสมัคร',
      '20': 'รหัสพนักงาน',
      '30': 'วันที่บันทึก',
      '40': 'หน่วยงาน',
      '50': 'ตำแหน่ง',
      '60': 'ลักษณะงาน',
      '70': 'หมายเหตุ',
      '80': 'วันที่เริ่มงานได้',
      '90': 'รายละเอียดตำแหน่งที่รับสมัคร'
    },
    'HRESS5UC4': {
      '0': 'รายละเอียดตำแหน่งที่รับสมัคร',
      '10': 'รายละเอียดตำแหน่งที่รับสมัคร',
      '20': 'หน่วยงาน',
      '30': 'ตำแหน่ง',
      '40': 'ลักษณะงาน',
      '50': 'จำนวนที่เปิดรับ',
      '60': 'วันที่เปิดรับสมัคร',
      '70': 'วันที่ปิดรับสมัคร',
      '80': 'คุณสมบัติที่ต้องการ',
      '90': 'รายละเอียดลักษณะงาน'
    },
    'HRESS5UC5': {
      '0': 'คุณสมบัติที่ต้องการ',
      '10': 'คุณสมบัติที่ต้องการ',
      '20': 'เลขที่ใบคำขอ',
      '30': 'ตำแหน่ง',
      '40': 'ลักษณะงาน',
      '50': 'ชื่อบริษัทเดิม',
      '60': 'คุณสมบัติที่ต้องการ',
      '70': 'ตามที่ระบุในลักษณะงาน',
      '80': 'กำหนดขึ้นใหม่',
      '90': 'เงื่อนไข',
      '100': 'หมายเหตุ'
    },
    'HRESS5UP1': {
      '0': 'รายละเอียดลักษณะงาน',
      '10': 'รายละเอียดลักษณะงาน',
      '20': 'ลักษณะงาน',
      '30': 'รายละเอียดลักษณะงาน',
      '40': 'รายละเอียด',
      '50': 'ความรับผิดชอบ',
      '60': 'เงื่อนไขการค้ำประกัน',
      '70': 'มูลค่าหลักทรัพย์',
      '80': 'บาท',
      '90': 'จำนวนผู้ค้ำประกัน',
      '100': 'คน',
      '110': 'ระยะเวลาสำรวจ',
      '120': 'ปี',
      '130': 'คุณสมบัติ',
      '140': 'แก้ไขครั้งสุดท้าย',
      '150': 'โดย'
    },
    'HRESS5UP2': {
      '0': 'ขอบเขตของงาน',
      '10': 'ขอบเขตของงาน',
      '20': 'ข้อที่',
      '30': 'หัวข้อเรื่อง',
      '40': 'รายละเอียด'
    },
    'HRESS5UP3': {
      '0': 'ขอบเขตความรับผิดชอบ',
      '10': 'ขอบเขตความรับผิดชอบ',
      '20': 'ข้อที่',
      '30': 'หัวข้อเรื่อง',
      '40': 'รายละเอียด'
    },
    'HRESS5UP4': {
      '0': 'ความสามารถพิเศษ',
      '10': 'ความสามารถพิเศษ',
      '20': 'รหัสความสามารถ',
      '30': 'รายละเอียด',
      '40': 'คะแนนเต็ม'
    },
    'HRESS5UP5': {
      '0': 'การศึกษา',
      '10': 'การศึกษา',
      '20': 'ลำดับที่',
      '30': 'รหัสระดับการศึกษา',
      '40': 'รายละเอียด',
      '50': 'คณะ/สาขาวิชา',
      '60': 'รายละเอียด',
      '70': 'เกรด'
    }
  }
}



// WEBPACK FOOTER //
// ./src/assets/labels/hress5u.js